import { Component, OnInit } from '@angular/core';
import { Zaposleni } from './zaposleni';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-zaposleni-update',
  templateUrl: './zaposleni-update.component.html'
})
export class ZaposleniUpdateComponent extends BaseUpdateComponent<Zaposleni> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("OsobaID", Validators.required, 'required', 'ZAPOSLENI.OSOBA.VALIDATION.REQUIRED');

  }

  onOsobaSelect(event){
    let i = event;
  }

}
